import { ManageAnnouncementForm } from './components';
import { Card, CardHeader } from 'app/components';
export const ManageAnnouncement = () => {
  return (
    <div>
      <CardHeader
        heading={'Manage Announcement'}
        subHeading={`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.`}
        helperText={''}
        mainHeader
      />
      <Card style={{ marginTop: '40px' }}>
        <ManageAnnouncementForm hideHeader />
      </Card>
    </div>
  );
};
export default ManageAnnouncement;
